(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clients"] && !window.DesignMode) return;
  try {
    
  class ClientsSection extends HTMLElement {
    constructor() {
      super();
      this.marquee = this.querySelector('[data-marquee]');
    }

    connectedCallback() {
      if (this.marquee) {
        this.setupMarquee();
      }
    }

    setupMarquee() {
      // Pause on hover is handled via CSS
      // Additional JavaScript functionality can be added here if needed
    }
  }

  customElements.define('clients-section', ClientsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-modern"] && !window.DesignMode) return;
  try {
    
  class HeroModern extends HTMLElement {
    connectedCallback() {
      this.initCopyCode();
      this.initRevealAnimations();
    }

    initCopyCode() {
      const copyButtons = this.querySelectorAll('[data-copy-code]');
      copyButtons.forEach(button => {
        button.addEventListener('click', () => {
          const code = button.parentElement.querySelector('code').textContent;
          navigator.clipboard.writeText(code).then(() => {
            button.innerHTML = '✓';
            setTimeout(() => {
              button.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10.5 2H3.5C2.67157 2 2 2.67157 2 3.5V10.5C2 11.3284 2.67157 12 3.5 12H10.5C11.3284 12 12 11.3284 12 10.5V3.5C12 2.67157 11.3284 2 10.5 2Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M14 5.5V12.5C14 13.3284 13.3284 14 12.5 14H5.5" stroke="currentColor" stroke-width="1.5"/>
              </svg>`;
            }, 2000);
          });
        });
      });
    }

    initRevealAnimations() {
      const reveals = this.querySelectorAll('.reveal');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, { threshold: 0.1 });

      reveals.forEach(reveal => observer.observe(reveal));
    }
  }

  customElements.define('hero-modern', HeroModern);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metrics"] && !window.DesignMode) return;
  try {
    
  class MetricsSection extends HTMLElement {
    constructor() {
      super();
      this.hasAnimated = false;
      this.counters = this.querySelectorAll('[data-counter]');
      this.items = this.querySelectorAll('[data-metric-item]');
    }

    connectedCallback() {
      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.animateMetrics();
          }
        });
      }, options);

      observer.observe(this);
    }

    animateMetrics() {
      // Animate items appearance
      this.items.forEach(item => {
        item.classList.add('animate');
      });

      // Animate counters
      this.counters.forEach(counter => {
        const target = parseFloat(counter.dataset.target);
        const duration = parseInt(counter.dataset.duration) || 2000;
        const format = counter.dataset.format || 'number';

        this.animateCounter(counter, target, duration, format);
      });
    }

    animateCounter(element, target, duration, format) {
      const startTime = performance.now();
      const start = 0;

      const updateCounter = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = start + (target - start) * easeOutQuart;

        // Format the number based on type
        let displayValue;
        if (format === 'decimal') {
          displayValue = current.toFixed(1);
        } else if (format === 'percentage') {
          displayValue = Math.round(current);
        } else {
          displayValue = Math.round(current).toLocaleString();
        }

        element.textContent = displayValue;

        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        }
      };

      requestAnimationFrame(updateCounter);
    }
  }

  customElements.define('metrics-section', MetricsSection);

  } catch(e) { console.error(e); }
})();
})();
